/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostChallengeSlugReferralsOwnCodeRequest
 */
export interface PostChallengeSlugReferralsOwnCodeRequest {
    /**
     * Optional user-supplied vanity code. When omitted, the server regenerates an auto-gen code using the challenge's referralCodePrefix. 3-32 chars, alphanumeric + hyphen + underscore only.
     * @type {string}
     * @memberof PostChallengeSlugReferralsOwnCodeRequest
     */
    code?: string;
}

/**
 * Check if a given object implements the PostChallengeSlugReferralsOwnCodeRequest interface.
 */
export function instanceOfPostChallengeSlugReferralsOwnCodeRequest(value: object): value is PostChallengeSlugReferralsOwnCodeRequest {
    return true;
}

export function PostChallengeSlugReferralsOwnCodeRequestFromJSON(json: any): PostChallengeSlugReferralsOwnCodeRequest {
    return PostChallengeSlugReferralsOwnCodeRequestFromJSONTyped(json, false);
}

export function PostChallengeSlugReferralsOwnCodeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostChallengeSlugReferralsOwnCodeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
    };
}

export function PostChallengeSlugReferralsOwnCodeRequestToJSON(json: any): PostChallengeSlugReferralsOwnCodeRequest {
    return PostChallengeSlugReferralsOwnCodeRequestToJSONTyped(json, false);
}

export function PostChallengeSlugReferralsOwnCodeRequestToJSONTyped(value?: PostChallengeSlugReferralsOwnCodeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
    };
}

